<template>
  <div class="taxInvoiceDetail">
    <van-form label-width="120px">
      <div v-if="form.menuState == 1">
        <!-- 可申请 -->
        <div class="title">{{ $t.meta.basicTitle }}</div>

        <van-field
          v-model="form.PWB_Number"
          :label="$t.taxInvoice.mainWbNumber"
          label-class="number-label"
          disabled
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="onCopy(form.PWB_Number)"
              v-if="form.PWB_Number"
              >{{ $t.meta.copy }}</van-button
            >
          </template>
        </van-field>

        <van-field
          v-model="form.WB_Number"
          :label="$t.taxInvoice.sideWbNumber"
          label-class="number-label"
          disabled
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="onCopy(form.WB_Number)"
              v-if="form.WB_Number"
              >{{ $t.meta.copy }}</van-button
            >
          </template>
        </van-field>

        <van-field
          v-model="form.CompanyNameSn"
          :label="$t.taxInvoice.payerName1"
          readonly
        />
        <van-field
          v-model="form.WarehouseWorkNumber"
          :label="$t.taxInvoice.warehouseWorkNumber"
          readonly
        />
        <van-field
          v-model="isPartialInvoice"
          :label="$t.taxInvoice.invoiceType2"
          readonly
        />
        <van-field v-model="form.Sales" :label="$t.taxInvoice.recommend" readonly />
        <van-field v-model="form.InvoiceNo" :label="$t.taxInvoice.invoiceNo" readonly />
        <van-field v-model="form.InvoiceDate" :label="$t.taxInvoice.billDate" readonly />

        <div class="title">{{ $t.taxInvoice.tradeTitle }}</div>
        <van-field v-model="form.POL" :label="$t.taxInvoice.deliveryPort" readonly />
        <van-field v-model="form.POD" :label="$t.taxInvoice.destinationPort" readonly />
        <van-field v-model="form.ATD" :label="$t.taxInvoice.atd" readonly />
        <div class="title">{{ $t.taxInvoice.amountTitle }}</div>
        <div
          class="subTotal"
          v-if="form.PayableAmountList && form.PayableAmountList.length > 0"
        >
          <div class="subTotal-label">{{ $t.taxInvoice.invoiceTotal }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.PayableAmountList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>

        <div class="subTotal">
          <div class="subTotal-label">{{ $t.taxInvoice.invoiceAmount }}</div>
          <div class="subTotal-item">
            <div class="item1">{{ settlementCurrency }}</div>
            <div class="item2">{{ form.PayableTotalAmount }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 已申请 / 已开票 -->
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.InvoiceNumber"
          :label="$t.taxInvoice.invoiceNumber"
          readonly
        />
        <van-field
          v-model="form.CreateTime"
          :label="
            form.menuState == 3 ? $t.taxInvoice.applyDate : $t.taxInvoice.invoiceDate
          "
          readonly
        />
        <van-field v-model="invoiceTypeStr" :label="$t.taxInvoice.invoiceType" readonly />
        <van-field
          v-model="form.CompanyNameSn"
          :label="$t.taxInvoice.payerName1"
          readonly
        />
        <van-field v-model="form.ItemName" :label="$t.taxInvoice.itemName" readonly />
        <van-field
          v-model="form.IssuedDate"
          :label="$t.taxInvoice.issuedDate"
          readonly
          v-if="form.menuState == 3"
        />
        <van-field v-model="form.UserName" :label="$t.taxInvoice.applicant" readonly />
        <van-field
          v-model="form.Remark"
          :label="$t.taxInvoice.remark"
          type="textarea"
          rows="5"
          readonly
        />

        <div class="title">{{ $t.taxInvoice.amountTitle }}</div>
        <div class="subTotal" v-if="subTotals && subTotals.length > 0">
          <div class="subTotal-label">{{ $t.taxInvoice.invoiceAmountSn }}</div>
          <div class="subTotal-item" v-for="(item, index) in subTotals" :key="index">
            <div class="item1">{{ item.key }}</div>
            <div class="item2">{{ item.value }}</div>
          </div>
        </div>

        <div class="title">{{ $t.taxInvoice.bankAccountInfo }}</div>
        <van-field
          v-model="bankForm.CustomerNumber"
          :label="$t.taxInvoice.customerNumber"
          readonly
        />
        <van-field v-model="bankForm.Currency" :label="$t.taxInvoice.currency" readonly />
        <van-field
          v-model="bankForm.AccountName"
          :label="$t.taxInvoice.accountName"
          readonly
        />
        <van-field v-model="bankForm.BankName" :label="$t.taxInvoice.bankName" readonly />
        <van-field
          v-model="bankForm.BankRegion"
          :label="$t.taxInvoice.bankRegion"
          readonly
        />
        <van-field
          v-model="bankForm.AccountNo"
          :label="$t.taxInvoice.bankNumber"
          readonly
        />
        <van-field v-model="bankForm.SwiftCodeBankNo" label="Swift Code" readonly />
        <van-field
          v-model="bankForm.BankAddress"
          :label="$t.taxInvoice.bankAddress"
          readonly
        />
        <van-field
          v-model="bankForm.CompanyAddressEn"
          :label="$t.taxInvoice.companyAddressEn"
          readonly
        />
        <van-field
          v-model="bankForm.EnterpriseId"
          :label="$t.taxInvoice.enterpriseId"
          readonly
        />
        <van-field
          v-model="bankForm.TelePhone"
          :label="$t.taxInvoice.telephone"
          readonly
        />
        <van-field
          v-model="bankForm.Address"
          :label="$t.taxInvoice.address"
          type="textarea"
          rows="5"
          readonly
        />
      </div>
    </van-form>

    <van-dialog
      :title="
        form.menuState == 3 ? $t.taxInvoice.viewInvoice : $t.taxInvoice.uploadinvoice
      "
      width="90%"
      v-model="showDialog"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="form.menuState == 3 ? false : true"
      className="taxInvoice-dialog"
    >
      <slot name="default">
        <div class="taxInvoice-alert">
          <div class="multi-table" v-if="dialogForm.list">
            <van-field name="stepper" :label="$t.taxInvoice.title">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="dialogForm.list.length"
                  @minus="handleDel"
                  @plus="handleAdd"
                  :disable-input="true"
                  :disabled="form.menuState == 3 ? true : false"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in dialogForm.list" :key="index">
              <div class="multi-table-header" v-if="form.menuState == 2">
                <div class="multi-table-title"></div>
                <div class="multi-table-btn" @click="handleDelByIndex(index)">
                  <van-icon name="close" />
                </div>
              </div>
              <van-field
                v-model="item.TaxInvoiceNumber"
                :label="$t.taxInvoice.invoiceNumber"
                :placeholder="$t.meta.input"
                required
                :disabled="form.menuState == 3 ? true : false"
              />
              <van-field :label="$t.taxInvoice.invoiceFile" required>
                <template #input>
                  <van-button
                    @click="imagePreview(imgUrlFilter(item.InvoiceFileAddress))"
                    type="primary"
                    size="small"
                    style="vertical-align: top; margin: 10px 30px 10px 0px"
                    v-if="item.InvoiceFileAddress"
                    >{{ $t.meta.view }}</van-button
                  >
                  <van-uploader
                    :after-read="afterRead1"
                    @click-upload="uploaderClick(index)"
                  >
                    <van-image
                      :src="
                        item.InvoiceFileAddress && imgUrlFilter(item.InvoiceFileAddress)
                      "
                      width="50"
                      height="50"
                      fit="contain"
                      style="vertical-align: top"
                      v-if="item.InvoiceFileAddress"
                    ></van-image>
                    <van-button
                      type="info"
                      size="small"
                      style="vertical-align: top; margin: 10px 30px 10px 0px"
                      v-else
                      >{{ $t.meta.upload }}</van-button
                    >
                  </van-uploader>
                </template>
              </van-field>
            </div>
          </div>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.taxInvoice.invoiceShare"
      width="90%"
      v-model="showEmailDialog"
      @confirm="emailConfirm"
      @cancel="emailCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <van-form label-width="80px">
          <van-field
            v-model="email"
            :label="$t.taxInvoice.emailAddress"
            type="textarea"
            required
          />
        </van-form>
      </slot>
    </van-dialog>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button
        type="info"
        block
        @click="toBillsReceivable"
        v-if="form.menuState == 1"
        >{{ $t.taxInvoice.billDetail }}</van-button
      >
      <van-button type="info" block @click="dialogShow" v-if="form.menuState == 2">{{
        $t.taxInvoice.addInvoice
      }}</van-button>

      <van-button type="info" block @click="handleSheetShow" v-if="form.menuState == 3">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Stepper,
  ActionSheet,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper)
  .use(ActionSheet);

export default {
  name: "taxInvoiceDetail",
  data() {
    return {
      settlementCurrency: "",
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      bankForm: {},
      isPartialInvoice: this.$t.meta.no,
      invoiceTypeStr: this.$t.taxInvoice.invoiceType1,
      subTotals: [],
      //弹窗
      showDialog: false,
      dialogForm: {
        list: [],
      },
      filesIndex: 0,
      //邮箱分享
      showEmailDialog: false,
      email: "",
      //操作菜单
      sheetShow: false,
      sheetActions: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("taxInvoiceDetail"));
    this.form = data;
    this.settlementCurrency = this.form.SettlementCurrency;
    this.firstLoad();
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    sheetSelect(e) {
      if (e.className == "1") {
        this.dialogShow();
      }
      if (e.className == "2") {
        this.dialogEmailShow();
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.taxInvoice.viewInvoice, className: "1" },
        { name: this.$t.taxInvoice.invoiceShare, className: "2" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    emailCancel() {
      this.showEmailDialog = false;
    },
    emailConfirm() {
      this.$commonMethod.showLoading();
      var param = {
        InvId: this.form.InvId,
        Email: this.email,
        UserId: this.UserId,
      };
      this.$api.financialManagement
        .getTaxInvoiceSharingEmail(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showEmailDialog = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogEmailShow() {
      this.showEmailDialog = true;
    },
    dialogCancel() {
      this.showDialog = false;
    },
    dialogConfirm() {
      this.$commonMethod.showLoading();
      var param = {
        InvId: this.form.InvId,
        IFileList: this.dialogForm.list,
        UserId: this.UserId,
      };
      this.$api.financialManagement
        .addInvoiceFile(param)
        .then((res) => {
          this.showDialog = false;
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogShow() {
      if (this.form.menuState == 3) {
        this.$commonMethod.showLoading();
        var param = {
          InvId: this.form.InvId,
        };
        this.$api.financialManagement
          .getInvoiceFileList(param)
          .then((res) => {
            this.dialogForm.list = res.data;
            this.showDialog = true;
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      } else {
        this.showDialog = true;
      }
    },
    firstLoad() {
      if (this.form.IsPartialInvoice == 1) {
        this.isPartialInvoice = this.$t.meta.yes;
      } else {
        this.isPartialInvoice = this.$t.meta.no;
      }
      if (this.form.InvoiceType == 2) {
        this.invoiceTypeStr = this.$t.taxInvoice.invoiceType2;
      } else {
        this.invoiceTypeStr = this.$t.taxInvoice.invoiceType1;
      }
      if (this.form.menuState != 1) {
        var test = Object.entries(this.form.SubTotalDic);
        var array = test.map(([key, value]) => ({
          key,
          value,
        }));
        this.subTotals = array;
      }
      this.getBankAccountInfoByBankId();
    },
    getBankAccountInfoByBankId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          BankId: this.form.BankId,
        };
        this.$api.financialManagement
          .getBankAccountInfoByBankId(param)
          .then((res) => {
            this.bankForm = res.data[0] || {};
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    toBillsReceivable() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: this.form.InvoiceNo,
          },
        ],
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    handleDelByIndex(index) {
      if (this.dialogForm.list.length > 0) {
        this.dialogForm.list.splice(index, 1);
      }
    },
    handleDel() {
      if (this.dialogForm.list.length > 0) {
        this.dialogForm.list.pop();
      }
    },
    handleAdd() {
      this.dialogForm.list.push({
        TaxInvoiceNumber: "",
        InvoiceFileAddress: "",
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.dialogForm.list[this.filesIndex].InvoiceFileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.taxInvoiceDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .taxInvoice-dialog {
    top: 50% !important;
    .taxInvoice-alert {
      overflow: scroll;
      height: 120vw;
      margin-bottom: 30px;
      .multi-table {
        margin-top: 20px;
        .multi-table-header {
          background: #ffffff;
          padding: 10px 15px;
          .multi-table-title {
            font-size: 14px;
            color: #999;
            width: 70%;
            display: inline-block;
            vertical-align: middle;
          }
          .multi-table-btn {
            font-size: 20px;
            color: #000;
            width: 30%;
            display: inline-block;
            text-align: right;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
